/**
 *
 * @Description:
 *
 * Dark NMC Tooltip
 *
 */

'use strict'

import {Tooltip} from '../Tooltip'

import PropTypes from 'prop-types'
import './TooltipDark.less'

const DARK_TOOLTIP_CLASS = 'nmc-dark-tooltip'

export default class DarkTooltip extends Tooltip {

}

DarkTooltip.propTypes = {
  placement: PropTypes.oneOf([Tooltip.TooltipPlacement.LEFT, Tooltip.TooltipPlacement.LEFT_BOTTOM, Tooltip.TooltipPlacement.LEFT_TOP, Tooltip.TooltipPlacement.RIGHT, Tooltip.TooltipPlacement.RIGHT_TOP, Tooltip.TooltipPlacement.RIGHT_BOTTOM, Tooltip.TooltipPlacement.TOP, Tooltip.TooltipPlacement.TOP_RIGHT, Tooltip.TooltipPlacement.TOP_LEFT, Tooltip.TooltipPlacement.BOTTOM, Tooltip.TooltipPlacement.BOTTOM_LEFT, Tooltip.TooltipPlacement.BOTTOM_RIGHT]),
  trigger: PropTypes.arrayOf(PropTypes.oneOf([Tooltip.TooltipTrigger.HOVER, Tooltip.TooltipTrigger.CLICK])),
  tooltipComponent: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func
  ]).isRequired
}

DarkTooltip.defaultProps = {
  placement: Tooltip.TooltipPlacement.BOTTOM,
  trigger: [Tooltip.TooltipTrigger.HOVER],
  prefixCls: DARK_TOOLTIP_CLASS
}




// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/DarkTooltip/index.js